import { NpsInterface } from "../../models/nps.models";
import { ReducerBuilder } from "../../utils/redux/reducer-builder";
import { GlobalTypes } from './../global-types';
import { INITIAL_STATE, NpsActionTypes, NpsState } from "./nps-types";

const reduxBuilder = new ReducerBuilder<NpsState>(INITIAL_STATE);

reduxBuilder.addReducer(GlobalTypes.CLEAR, () => {
    return INITIAL_STATE;
});

reduxBuilder.addMutableReducer(NpsActionTypes.FETCH_SHOW_NPS, (state) => {
    state.showNps = true;
});

reduxBuilder.addMutableReducer(NpsActionTypes.FETCH_HIDE_NPS, (state) => {
    state.showNps = false;
});

reduxBuilder.addMutableReducer(NpsActionTypes.FETCH_NPS_DATA, (state) => {
    state.nps = INITIAL_STATE.nps;
});

reduxBuilder.addMutableReducer<NpsInterface[]>(NpsActionTypes.FETCH_NPS_DATA_SUCCESS, (state, payload) => {
    state.nps.loading = false;
    state.nps.data = payload;
});

reduxBuilder.addMutableReducer<any>(NpsActionTypes.FETCH_NPS_DATA_ERROR, (state, payload) => {
    state.nps.loading = false;
    state.nps.error = payload;
});

export default reduxBuilder.build();